import {
  ApiResponse,
  EventDownloadResponse,
  EventUIResponse,
} from "../../models/ApiResponse";
import {
  AddEventRequest,
  UpdateEventRequest,
} from "../../models/requestModels/eventRequest";
import { EventResponse } from "../../models/responseModels/eventResponse";
import { axiosRequests } from "../axiosRequest";

export const EventAgent = {
  getEventList: () => axiosRequests.get<EventUIResponse>("/event/GetEventList"),
  eventCsvDownload: (eventData: EventResponse[]) =>
    axiosRequests.post<EventDownloadResponse>("/event/DownloadCsv", eventData),
  eventXlsxDownload: (eventData: EventResponse[]) =>
    axiosRequests.postXlsx<Blob>("/event/DownloadXlsx", eventData),
  updateEvent: (eventData: UpdateEventRequest) =>
    axiosRequests.post<ApiResponse>("/event/updateEvent", eventData),
  addEvent: (eventData: AddEventRequest) =>
    axiosRequests.post<ApiResponse>("/event/addEvent", eventData),
};
